/**
 * Прибавка бота к росту отрядов за снабжение строками (см.
 * configs/botLeagueSupplyGrowth) — одна на подсказку значка бота и на раздел
 * правил «Боты». Пустой массив — прибавки нет.
 *
 * @param {{barracks: number, other: number}} [bonus]
 * @returns {string[]}
 */
export const getBotSupplySizeBonusLines = (bonus) => {
  const barracks = (bonus && bonus.barracks) || 0;
  const other = (bonus && bonus.other) || 0;
  if (barracks > 0 && barracks === other) {
    return [`+${barracks} к росту размера отрядов везде`];
  }

  const lines = [];
  if (barracks > 0) {
    lines.push(`+${barracks} к росту размера отрядов на казарме`);
  }
  if (other > 0) {
    lines.push(`+${other} к росту размера отрядов вне казармы`);
  }
  return lines;
};
